import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductResource } from '@df/catalog/product/product.resource';
import { Events } from '@df/core/service/event';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { NBuilderConfig } from '../../common/builder.config';
import { BuilderSimpleStepComponent } from '../../common/simple-step/simple-step.component';
import { NKitBuilder } from '../page-kit-builder-view.component';
import { NKitGeneralSetup } from './kit-general-setup.config';
@Component({
    selector: 'kit-general-setup',
    templateUrl: './kit-general-setup.html',
    styleUrls: ['./kit-general-setup.scss'],
    standalone: true,
    imports: [BuilderSimpleStepComponent, DfUiModule, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KitGeneralSetupComponent implements OnChanges {
    @Input()
    content: NKitGeneralSetup.IGeneralSetupData;
    @Input()
    storageData: NKitBuilder.IStorageData;
    protected ponyStepData: NBuilderConfig.ISimpleStep;
    constructor(
        private events: Events,
        private changeDetectorRef: ChangeDetectorRef,
        private productResources: ProductResource
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['content']) {
            // to do check if product in setupData is salable
            this.ponyStepData = {
                title: this.content.firstStepTitle,
                tabs: [
                    {
                        title: 'Pony',
                        id: 0,
                        options: this.content.firstStepOptions.filter(o => this.productResources.getExisting(o.productId)?.isSalable())
                    }
                ]
            };
        }
        this.changeDetectorRef.detectChanges();
    }
    protected next() {
        if (this.isDataValid()) {
            this.storageData.step = NKitBuilder.ESteps.products;
            this.changeDetectorRef.detectChanges();
            this.updateStorage();
        }
    }
    protected isDataValid(): boolean {
        return this.storageData.pony !== undefined;
    }
    protected updateStorage(): void {
        this.changeDetectorRef.detectChanges();
        this.events.broadcast(NBuilderConfig.updateStorageEvent);
    }
}
